module.exports = __webpack_public_path__ + "static/PersonCleaningBathroomSink-c5f1eeb58c016a7045b87e71028cd40f.jpg";